import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_ENDPOINTS } from "../config/api";

import Button from "../components/Button";
import { Input } from "../components/Input";
import { Form, FormGroup, Label } from "../components/Form";
import { ErrorState, SuccessState } from "../components/CommonStates";
import { Card } from "../components/Card";
import { FieldDescription } from "../components/Form";

function ChangePassword({ user, onLogin }) {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: ""
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    if (formData.newPassword.length < 8) {
      setError("New password must be at least 8 characters long");
      return false;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError("New passwords do not match");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setMessage("");

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    try {
      const token = localStorage.getItem("token");
      const response = await fetch(API_ENDPOINTS.changePasswordAfterReset, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({
          newPassword: formData.newPassword
        })
      });

      const data = await response.json();

      if (response.ok) {
        // Update the user data to clear the requirePasswordChange flag
        if (data.user) {
          onLogin(data.user, token);
        }

        // Redirect to dashboard immediately
        navigate("/dashboard");
      } else {
        setError(data.error || "Password update failed");
      }
    } catch (error) {
      setError("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card>
      <div
        style={{
          background: "rgb(255, 236, 170)",
          border: "2px solid rgb(242, 218, 136)",
          borderRadius: "0.5rem",
          padding: "1rem",
          marginBottom: "2rem"
        }}
      >
        <h4 style={{ margin: "0 0 0.5rem 0" }}>⚠️ Password reset required</h4>
        <p style={{ margin: 0 }}>
          Your password has been reset by an admin. Please create a new
          password.
        </p>
      </div>

      {error && <ErrorState>{error}</ErrorState>}
      {message && <SuccessState>{message}</SuccessState>}

      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label htmlFor="newPassword">New password</Label>
          <Input
            type="password"
            id="newPassword"
            name="newPassword"
            value={formData.newPassword}
            onChange={handleChange}
            required
            disabled={loading}
            minLength="8"
            placeholder="Enter your new password"
          />
          <FieldDescription>
            Password must be at least 8 characters long
          </FieldDescription>
        </FormGroup>

        <FormGroup>
          <Label htmlFor="confirmPassword">Confirm new password</Label>
          <Input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
            disabled={loading}
            minLength="8"
            placeholder="Confirm your new password"
          />
        </FormGroup>

        <Button type="submit" disabled={loading} fullWidth>
          {loading ? "Updating..." : "Update password"}
        </Button>
      </Form>
    </Card>
  );
}

export default ChangePassword;
